import CloseIcon from "@mui/icons-material/Close";
import { Button, IconButton, Modal, styled } from "@mui/material";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Carousel } from "react-responsive-carousel";
import { notificationModalInfo } from "./constants";
import authOperations from "./ducks/operations";

const StyledPaper = styled("div")(({ theme }) => ({
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: theme.spacing(70),
    backgroundColor: "#2b2f3e",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(1),
    borderRadius: "3px",
    "&:focus": {
        outline: "none",
    },
    textAlign: "center",
}));

const StyledIconButton = styled(IconButton)({
    width: 20,
    height: 20,
    padding: 0,
    top: -10,
    right: -10,
    position: "absolute",
    backgroundColor: "white",
    "&:hover": {
        backgroundColor: "white",
    },
});

const StyledButton = styled(Button)({
    backgroundColor: "#2b2f3e",
    outline: "2px solid #2596be",
    color: "white",
    display: "block",
    margin: "10px auto",
    padding: "2px 20px",
});

const StyledTitle = styled("h4")({
    color: "white",
    fontSize: "20px",
    margin: "10px",
});

const StyledText = styled("div")({
    color: "white",
    whiteSpace: "pre-wrap",
    fontSize: "15px",
    marginBottom: "10px",
});

const StyledVideo = styled("video")({
    margin: "0 auto",
    maxWidth: "100%",
    maxHeight: "100%",
    flex: 1,
    minWidth: 0,
});

const StyledDiv = styled("div")({
    display: "flex",
    maxHeight: "500px",
    height: "250px",
});

const StyledCarouselSlide = styled("div")({
    display: "flex",
    flexDirection: "column",
    margin: "0px 30px",
    paddingBottom: "30px",
    paddingTop: "20px",
});

const NotificationModal = (props) => {
    const { acknowledgeNotification, getNotificationAcknowledgement, hideNotification, loggedIn, displayModal } = props;

    const [currentSlide, setCurrentSlide] = useState(0);

    useEffect(() => {
        if (loggedIn || displayModal) {
            getNotificationAcknowledgement();
        }
    }, []);

    useEffect(() => {
        if (hideNotification === true || hideNotification === undefined) return;

        const currentInterval = notificationModalInfo[currentSlide]?.interval;
        if (currentInterval === 0) return;

        const timer = setTimeout(() => {
            setCurrentSlide((prev) => prev + 1);
        }, currentInterval);

        return () => clearTimeout(timer);
    }, [currentSlide, hideNotification]);

    return (
        <Modal
            aria-labelledby="feature-notification-modal-title"
            aria-describedby="feature-notification-description"
            open={hideNotification === false && (displayModal || loggedIn)}
        >
            <StyledPaper>
                <StyledIconButton onClick={acknowledgeNotification}>
                    <CloseIcon sx={{ fontSize: 15 }} />
                </StyledIconButton>
                <Carousel
                    showThumbs={false}
                    showStatus={false}
                    infiniteLoop
                    selectedItem={currentSlide}
                    onChange={setCurrentSlide}
                >
                    {notificationModalInfo.map((slide, index) => {
                        const shouldLoadVideo = index === currentSlide;
                        return (
                            <StyledCarouselSlide key={index}>
                                <StyledDiv>
                                    {shouldLoadVideo && <StyledVideo src={slide.src} autoPlay loop muted />}
                                </StyledDiv>
                                <StyledTitle id="feature-notification-modal-title">{slide.title}</StyledTitle>
                                <StyledText id="feature-notification-description">{slide.description}</StyledText>
                            </StyledCarouselSlide>
                        );
                    })}
                </Carousel>
                <StyledButton onClick={acknowledgeNotification}>Got it</StyledButton>
            </StyledPaper>
        </Modal>
    );
};

const mapStateToProps = (state) => {
    return {
        hideNotification: state.authReducer.authenticatedUserProfile.notificationAcknowledgedFlg,
        loggedIn: state.authReducer.loggedIn,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        acknowledgeNotification: () => dispatch(authOperations.acknowledgeNotification()),
        getNotificationAcknowledgement: () => dispatch(authOperations.getNotificationAcknowledgement()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(NotificationModal);
